var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1V5H1C0.447715 5 0 5.44772 0 6V12C0 12.5523 0.447715 13 1 13H3V15C3 15.5523 3.44772 16 4 16H12C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12V6C16 5.44772 15.5523 5 15 5H13V1C13 0.447715 12.5523 0 12 0H4C3.44772 0 3 0.447715 3 1ZM5 2V5H11V2H5ZM13 9C13.5523 9 14 8.55229 14 8C14 7.44772 13.5523 7 13 7C12.4477 7 12 7.44772 12 8C12 8.55229 12.4477 9 13 9ZM11 14H5V12H11V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.1ba4c9c2031cc765ed8900445aeac51d.svg";
export { ForwardRef as ReactComponent };